module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAYUlEQVQ4T2NkIADS0tJCQUqYmZn3TJ8+/T0u5Yz4zMnMzBT8+/fvO6iasFmzZq0eNQg1BIZ4GKWnp5cDPQROK9jA////jUHijIyMZ/EklbOMVDNoNEGCQmA0r+FIB8QWbADHkIevqtP46wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ic_add.png
// module id = LJZT
// module chunks = 1